export default "__VITE_ASSET__DbfYV9hx__"